let model = {};

model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  user_id: undefined, // required, ref: user - Mã người dùng
  chua_duyet: undefined, // optional - Cho biết có phải đăng ký chưa được duyệt
  cong_ty_lu_hanh_id: undefined, // required, ref: cong_ty_lu_hanh - Mã công ty lữ hành
  created_time: undefined, // required - Thời gian tạo
};

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100, 500],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "",
  defaultSort: ["", "descending"],
  filters: "",
  recordSelected: [],
  dataSearch: {
    value: {
      cong_ty_lu_hanh_id: "",
      created_time: "",
      "giay_phep_kinh_doanh.so_giay_phep": "",
    },
    valid: {},
    operator: {
      cong_ty_lu_hanh_id: "",
      created_time: ":in_that_day:",
      "giay_phep_kinh_doanh.so_giay_phep": "",
    },
  },
};

export default model;
